import React from "react"
import { Shelter } from "../types/shelter"
import { addressOrDistance } from "../Utils/place_helper"
import Lamp from "../Common/Place/Summary/Lamp"
import Icon from "../Utils/Icon"

import * as styles from "./Styles/Row.module.scss"

const Row: React.FC<{
  shelter: Shelter
}> = ({ shelter }) => {
  const address = shelter.place.address
  const distance = shelter.distance

  return (
    <a href={shelter.path} className={styles.row}>
      <div className={styles.container}>
        <div>
          {distance && (
            <div className={styles.annotation}>
              {addressOrDistance(null, distance)}
            </div>
          )}
          <div className={styles.name}>{shelter.place.name}</div>
          <div className={styles.annotation}>
            {addressOrDistance(address, null)}
          </div>
          <Lamp lamp={shelter.crowdStatus} />
        </div>
        <div className={styles.arrow}>
          <Icon
            type="feather"
            name="chevron-right"
            className={styles.arrowIcon}
            attr={{ width: 20, height: 20 }}
          />
        </div>
      </div>
    </a>
  )
}
export default Row
